module.exports = __webpack_public_path__ + "img/search.ee1485f9.jpg";